import { render, staticRenderFns } from "./makeUpOrderSystem.vue?vue&type=template&id=6349bd06"
import script from "./makeUpOrderSystem.vue?vue&type=script&lang=js"
export * from "./makeUpOrderSystem.vue?vue&type=script&lang=js"
import style0 from "./makeUpOrderSystem.vue?vue&type=style&index=0&id=6349bd06&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports